import axios from "axios"
import { EmployeeAddress } from "@type/employees.types"

const ROOT_PATH = "employees/address"
export default class EmployeeAddressService {
	static createEmployeeAddress = (payload: EmployeeAddress) => axios.post<EmployeeAddress>(`${ROOT_PATH}`, payload)

	static updateEmployeeAddress = (employeeId: string, payload: EmployeeAddress) =>
		axios.put<EmployeeAddress>(`${ROOT_PATH}/${employeeId}`, payload)

	static getEmployeeAddresses = (employeeId: string) => axios.get<EmployeeAddress[]>(`${ROOT_PATH}/${employeeId}`)
}
